import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { DialogData } from './dialog.interface'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Component({
  selector: 'app-dtcm-dialog',
  styleUrls: ['./dialog.component.scss'],
  templateUrl: './dtcm.dialog.component.html',
  imports: [CommonModule]
})
export class DTCMDialog {
  /** Injectable dialog reference */
  protected readonly dialogRef: MatDialogRef<DTCMDialog> = inject(MatDialogRef<DTCMDialog>)
  /** Injectable dialog data */
  protected readonly data: DialogData = inject(MAT_DIALOG_DATA)
  public slug: string
  public legalRegulator: { name: SafeHtml; acronym: string; link: string; logo: string } = { acronym: '', link: '', logo: '', name: '' }

  private _sanitizer: DomSanitizer = inject(DomSanitizer)

  ngOnInit(): void {
    const cityLower = this.data.city.toLowerCase().trim()

    // Check for Dubai
    if (cityLower === 'dubai') {
      this.legalRegulator['name'] = this._sanitizer.bypassSecurityTrustHtml('Dubai <strong>Economy & Tourism (DET)</strong>')
      this.legalRegulator['acronym'] = 'DET'
      this.legalRegulator['link'] = 'https://www.dubaitourism.gov.ae/en/services/apply-for-an-event-permit'
      this.legalRegulator['logo'] = 'assets/images/dtcmlogo.svg'
      return
    }

    // Check for Abu Dhabi (handles both "abu dhabi" and "abu dhabi region")
    if (cityLower.includes('abu dhabi')) {
      this.legalRegulator['name'] = this._sanitizer.bypassSecurityTrustHtml('Abu Dhabi <strong>Department of Culture & Tourism (DCT)</strong>')
      this.legalRegulator['acronym'] = 'DCT'
      this.legalRegulator['link'] = 'https://dct.gov.ae/en/e.services/events.licensing.system.aspx'
      this.legalRegulator['logo'] = 'assets/images/dctlogo.png'
      return
    }

    // Default case
    this.legalRegulator['name'] = ''
    this.legalRegulator['acronym'] = ''
    this.legalRegulator['link'] = ''
    this.legalRegulator['logo'] = ''
  }

  proceed(slug) {
    this.dialogRef.close(slug)
  }
}
